module.exports = __webpack_public_path__ + "img/01.b58667cd.png";